import { render, staticRenderFns } from "./BonusPeriodColumnTemplate.vue?vue&type=template&id=40438c22"
import script from "./BonusPeriodColumnTemplate.vue?vue&type=script&lang=js"
export * from "./BonusPeriodColumnTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports